import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/getClaimantPercentile';
// FOR ONE GRAPHQL QUERY
export const ClAIMANT_PERCENTILE = defineAsyncActionTypes(`${prefix}/CLAIMANT_PERCENTILE`);
